var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Box, Button, Drawer, FormControl, Grid, IconButton, Switch, TextField, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Add01Icon, Edit02Icon, Search01Icon } from 'hugeicons-react';
import { useMemo, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { AppConsts } from '../../../application/common/constants/app-consts';
import { getDataGridLocaleText } from '../../../application/common/constants/get-data-grid-locale-text';
import { getFilteredStringOperators } from '../../../application/common/helpers/grid-filter-operators';
import { useGetPaginatedUsersQuery } from '../../../application/features/users/user-api';
import { useAppSelector } from '../../../application/store/useStore';
import useTranslate from '../../../localization/helpers';
import FilterButton from '../../components/FilterButton';
import PageHeaderButton from '../../components/PageHeaderButton';
import ProtectedElement from '../../components/ProtectedElement';
import { Permissions } from '../../permissions';
import ActivateMultipleUsersDialog from './multiple-user-status/ActivateMultipleUsers';
import DeActivateMultipleUsersDialog from './multiple-user-status/DeActivateMultipleUsers';
import ActivateUserDialog from './user-status/ActivateUser';
import DeActivateUserDialog from './user-status/DeActivateUser';
import UsersCard from './users-cards';
var Users = function () {
    var _a, _b, _c, _d;
    var theme = useTheme();
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var _e = useTranslate(), translate = _e.translate, tWithFunction = _e.tWithFunction;
    var navigate = useNavigate();
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var isMd = useMediaQuery(theme.breakpoints.only('md'));
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen9001200Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var iscreen900120Landscape = useMediaQuery('(min-width:901px) and (max-width:1200px) and (orientation: landscape)');
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var isIpadMiniLandscape = useMediaQuery('(max-width: 1024px) and (orientation: landscape)');
    var isLg = useMediaQuery(theme.breakpoints.up('lg'));
    var _f = __read(useState(), 2), selectionModel = _f[0], setSelectionModel = _f[1];
    var _g = __read(useState(true), 2), switchState = _g[0], setSwitchState = _g[1];
    var _h = __read(useState({ isOpen: false, isActive: false }), 2), userStatusModal = _h[0], setUserStatusModal = _h[1];
    var _j = __read(useState({ isOpen: false, isActive: false }), 2), multipleUserStatusModal = _j[0], setMultipleUserStatusModal = _j[1];
    var activationModalOpen = userStatusModal.isOpen && userStatusModal.isActive;
    var deActivationModalOpen = userStatusModal.isOpen && !userStatusModal.isActive;
    var multipleActivationModalOpen = multipleUserStatusModal.isOpen && multipleUserStatusModal.isActive;
    var multipleDeActivationModalOpen = multipleUserStatusModal.isOpen && !multipleUserStatusModal.isActive;
    var _k = __read(useState({
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        sortField: AppConsts.DEFAULT_SORT_FIELD,
        name: null,
        filterField: undefined,
        filterOperator: undefined,
        filterValue: undefined
    }), 2), userFilters = _k[0], setUserFilters = _k[1];
    var _l = __read(useState({
        items: []
    }), 2), filterModel = _l[0], setFilterModel = _l[1];
    var _m = useGetPaginatedUsersQuery(userFilters), data = _m.data, isUsersFetching = _m.isFetching;
    var _o = (data !== null && data !== void 0 ? data : {}).items, users = _o === void 0 ? [] : _o;
    var _p = __read(useState(false), 2), openFilterDrawer = _p[0], setOpenFilterDrawer = _p[1];
    var handleFilterClick = function () {
        setOpenFilterDrawer(function (prev) { return !prev; });
    };
    var _q = useForm({
        defaultValues: {
            name: null
        }
    }), control = _q.control, handleSubmit = _q.handleSubmit, getValues = _q.getValues, reset = _q.reset, errors = _q.formState.errors;
    var handlePaginationModelChange = function (model) {
        setUserFilters(function (prev) { return (__assign(__assign({}, prev), { page: model.page + 1, pageSize: model.pageSize })); });
    };
    var handleSortModelChange = function (model) {
        setUserFilters(function (prev) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prev), { sortField: (_b = (_a = model[0]) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : AppConsts.DEFAULT_SORT_FIELD, sortDirection: (_d = (_c = model[0]) === null || _c === void 0 ? void 0 : _c.sort) !== null && _d !== void 0 ? _d : AppConsts.DEFAULT_SORT_DIRECTION }));
        });
    };
    var handleFilterModelChange = function (model) {
        if (model.items.length > 0) {
            var filterItem_1 = model.items[0];
            if (filterItem_1.operator !== 'isEmpty' &&
                filterItem_1.operator !== 'isNotEmpty' &&
                (filterItem_1.value === '' ||
                    (Array.isArray(filterItem_1.value) && filterItem_1.value.length === 0) ||
                    filterItem_1.value === undefined)) {
                setUserFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
            }
            else {
                setUserFilters(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), { filterField: filterItem_1.field, filterOperator: filterItem_1.operator, filterValue: (_a = filterItem_1.value) === null || _a === void 0 ? void 0 : _a.toString() }));
                });
            }
        }
        else {
            // When model.items is empty, clear all filters
            setUserFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
        }
        setFilterModel(model);
    };
    var handleSelectionModelChange = function (newSelection) {
        setSelectionModel(newSelection);
        var selectedUsers = users.filter(function (user) { return newSelection.ids.has(user.id); });
        if (selectedUsers.length > 1) {
            var activeCount = selectedUsers.filter(function (user) { return user.isActive; }).length;
            var inactiveCount = selectedUsers.length - activeCount;
            setSwitchState(activeCount > inactiveCount);
        }
        else {
            setSwitchState(true);
        }
    };
    var handleStatusChange = function (event) {
        var newSwitchState = event.target.checked;
        var selectedUsers = users
            .map(function (x) { return x.id; })
            .filter(function (userId) { return selectionModel === null || selectionModel === void 0 ? void 0 : selectionModel.ids.has(userId); });
        openMultipleUserStatusModal(selectedUsers, newSwitchState);
    };
    var rowCountRef = useRef((data === null || data === void 0 ? void 0 : data.totalCount) || 0);
    var rowCount = useMemo(function () {
        if ((data === null || data === void 0 ? void 0 : data.totalCount) !== undefined) {
            rowCountRef.current = data === null || data === void 0 ? void 0 : data.totalCount;
        }
        return rowCountRef.current;
    }, [data === null || data === void 0 ? void 0 : data.totalCount]);
    var generateUserColumns = function () {
        var keys = [
            'firstName',
            'lastName',
            'email',
            'role',
            'primaryCompany'
        ];
        var headers = {
            firstName: translate('users.firstName'),
            lastName: translate('users.lastName'),
            email: translate('users.email'),
            role: translate('common.role'),
            primaryCompany: translate('users.primaryCompany')
        };
        var baseColumns = keys.map(function (key) { return ({
            field: key,
            headerName: headers[key] || key.charAt(0).toUpperCase() + key.slice(1),
            type: 'string',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 2 : 2,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 330 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterOperators: getFilteredStringOperators()
        }); });
        baseColumns.push({
            field: 'isActive',
            headerName: translate('common.active'),
            filterable: false,
            renderCell: function (params) { return (_jsx(ProtectedElement, { permissions: [Permissions.Users.Update], children: _jsx(Switch, { checked: params.value, onClick: function (e) {
                        e.stopPropagation();
                        openUserStatusModal(params.row, !params.value);
                    }, disabled: params.row.id === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId) }) })); },
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined
        });
        baseColumns.push({
            field: 'edit',
            headerName: translate('actions.edit'),
            align: 'center',
            filterable: false,
            disableColumnMenu: true,
            sortable: false,
            headerAlign: 'center',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            renderCell: function (params) { return (_jsx(ProtectedElement, { permissions: [Permissions.Users.Update], children: _jsx(IconButton, { size: 'medium', onClick: function () { return navigate("/users/edit-user/".concat(params.row.id)); }, children: _jsx(Edit02Icon, {}) }) })); }
        });
        return baseColumns;
    };
    var usersColumns = generateUserColumns();
    var isRowSelectable = function (params) {
        var _a, _b;
        return ((_a = params.row) === null || _a === void 0 ? void 0 : _a.role) && ((_b = params.row) === null || _b === void 0 ? void 0 : _b.isRoleActive);
    };
    var openUserStatusModal = function (user, isActive) {
        setUserStatusModal({
            user: user,
            isOpen: true,
            isActive: isActive
        });
    };
    var closeUserStatusModal = function () {
        setUserStatusModal({
            isOpen: false,
            isActive: false
        });
    };
    var openMultipleUserStatusModal = function (selectedUsers, isActive) {
        setMultipleUserStatusModal({
            selectedUsers: selectedUsers,
            isOpen: true,
            isActive: isActive
        });
    };
    var closeMultipleUserStatusModal = function () {
        setMultipleUserStatusModal({
            isOpen: false,
            isActive: false
        });
    };
    var filterUsers = function () {
        setUserFilters(__assign(__assign({}, userFilters), { name: getValues('name') }));
    };
    return (_jsxs(Box, { sx: {
            width: '100%',
            padding: isXs ? '16px' : '8px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', justifyContent: isXs || isscreen600900 || iscreen9001200 || isscreen600900Landscape ? 'space-between' : '', mb: { xs: 0, md: 0, lg: 2 }, gap: 1, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(Typography, { variant: isXs ? 'h4' : 'h3', color: '#009983', children: translate('common.users') }), _jsx(ProtectedElement, { permissions: [Permissions.Users.Create], children: _jsx(PageHeaderButton, { text: translate('actions.add'), icon: _jsx(Add01Icon, { size: isXs ? 17 : undefined }), size: isXs ? 'small' : 'medium', onClick: function () { return navigate('/users/new-user'); }, variant: 'contained', color: 'primary', title: tWithFunction('actions.addFunction', 'common.user') }) })] }), !isXs && !isIpadMini && !isIpadMiniLandscape && !isLg && (_jsx(FilterButton, { variant: 'soft', onClick: handleFilterClick }))] }), isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(UsersCard, { userFilters: userFilters, setUserFilters: setUserFilters, users: users, onEditUser: function (userId) { return navigate("/users/edit-user/".concat(userId)); }, onToggleStatus: function (user, isActive) { return openUserStatusModal(user, isActive); }, onMultipleStatusChange: function (selectedUsers, isActive) {
                    return openMultipleUserStatusModal(selectedUsers, isActive);
                }, handleSubmit: handleSubmit, control: control, reset: reset, filterUsers: filterUsers, isUsersFetching: isUsersFetching, isXs: isXs, errors: errors, switchState: switchState, setSwitchState: setSwitchState })) : (_jsxs(Box, { sx: { width: '100%' }, children: [!isscreen600900 && !iscreen9001200 && (_jsx(Box, { mt: 1, component: 'form', noValidate: true, mb: 2, onSubmit: handleSubmit(filterUsers), children: _jsxs(Grid, { container: true, spacing: { xs: 1, md: 2 }, children: [_jsx(Grid, { size: { xs: 12, lg: 10 }, children: _jsx(Controller, { name: 'name', control: control, render: function (_a) {
                                            var _b = _a.field, onChange = _b.onChange, value = _b.value;
                                            return (_jsx(FormControl, { fullWidth: true, children: _jsx(TextField, { size: 'small', disabled: isUsersFetching, label: translate('common.name'), type: 'text', onChange: onChange, value: value, fullWidth: true, slotProps: {
                                                        input: {
                                                            sx: {
                                                                borderRadius: '8px',
                                                                height: '39.12px'
                                                            }
                                                        }
                                                    }, error: !!errors.name }) }));
                                        } }) }), _jsx(Grid, { size: { xs: 12, lg: 2 }, children: _jsx(Button, { type: 'submit', variant: 'soft', fullWidth: true, size: isXs ? 'small' : 'medium', startIcon: _jsx(Search01Icon, { size: 15 }), children: translate('actions.search') }) })] }) })), _jsx(Box, { mt: isXs || iscreen9001200 || isscreen600900 || iscreen9001200 || isscreen600900Landscape
                            ? 1
                            : '', children: _jsxs(Box, { sx: {
                                p: { xs: 0.5, md: 2 },
                                backgroundColor: 'white',
                                borderRadius: '16px',
                                boxShadow: '0 24px 48px 0 #919EAB29',
                                height: __assign(__assign({ xs: 'calc(100svh - 225px)', sm: ((_a = selectionModel === null || selectionModel === void 0 ? void 0 : selectionModel.ids.size) !== null && _a !== void 0 ? _a : 0) > 0
                                        ? 'calc(100svh - 229px)'
                                        : 'calc(100svh - 229px)' }, (isscreen600900 && { sm: 'calc(100svh - 242px)' })), (isscreen9001200Landscape
                                    ? { sm: '400px' }
                                    : iscreen9001200
                                        ? { sm: 'calc(100svh - 242px)' }
                                        : {}))
                            }, children: [_jsxs(Drawer, { open: openFilterDrawer, onClose: function () { return setOpenFilterDrawer(false); }, anchor: 'bottom', slotProps: {
                                        paper: {
                                            sx: {
                                                borderTopLeftRadius: 24,
                                                borderTopRightRadius: 24
                                            }
                                        }
                                    }, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', padding: '24px 12px 24px 24px', alignItems: 'center', children: [_jsx(Typography, { variant: 'h6', children: translate('common.filters') }), _jsx(IconButton, { size: 'Xs', onClick: function () {
                                                        setOpenFilterDrawer(false);
                                                        reset(userFilters);
                                                    }, children: _jsx(Icon, { icon: 'mingcute:close-line' }) })] }), _jsxs(Box, { px: '24px', component: 'form', noValidate: true, onSubmit: function (e) {
                                                handleSubmit(filterUsers)();
                                                e.preventDefault();
                                                setOpenFilterDrawer(false);
                                            }, children: [_jsx(Grid, { container: true, spacing: { xs: 1, md: 2 }, children: _jsx(Grid, { size: { xs: 12, lg: 10 }, children: _jsx(Controller, { name: 'name', control: control, render: function (_a) {
                                                                var _b = _a.field, onChange = _b.onChange, value = _b.value;
                                                                return (_jsx(FormControl, { fullWidth: true, children: _jsx(TextField, { size: 'small', disabled: isUsersFetching, label: translate('common.name'), type: 'text', onChange: onChange, value: value, fullWidth: true, slotProps: {
                                                                            input: {
                                                                                sx: {
                                                                                    borderRadius: '8px',
                                                                                    height: '39.12px'
                                                                                }
                                                                            }
                                                                        }, error: !!errors.name }) }));
                                                            } }) }) }), _jsxs(Box, { py: '24px', display: 'flex', gap: '12px', justifyContent: 'center', children: [_jsx(Button, { variant: 'outlined', fullWidth: true, color: 'inherit', size: 'medium', onClick: function () {
                                                                setOpenFilterDrawer(false);
                                                                reset(userFilters);
                                                            }, children: translate('actions.cancel') }), _jsx(Button, { type: 'submit', variant: 'contained', fullWidth: true, color: 'inherit', size: 'medium', children: translate('actions.apply') })] })] })] }), ((_b = selectionModel === null || selectionModel === void 0 ? void 0 : selectionModel.ids.size) !== null && _b !== void 0 ? _b : 0) > 0 && (_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 1, children: [_jsx(Box, { children: _jsxs(Typography, { variant: 'body1', children: [selectionModel === null || selectionModel === void 0 ? void 0 : selectionModel.ids.size, " ", translate('common.selected')] }) }), _jsxs(Box, { display: 'flex', alignItems: 'center', visibility: ((_c = selectionModel === null || selectionModel === void 0 ? void 0 : selectionModel.ids.size) !== null && _c !== void 0 ? _c : 0) > 1 ? 'visible' : 'hidden', children: [_jsx(Typography, { variant: 'body1', children: translate(switchState ? 'common.deactivate' : 'common.activate') }), _jsx(Tooltip, { title: translate(switchState ? 'common.deactivate' : 'common.activate'), arrow: true, children: _jsx(ProtectedElement, { permissions: [Permissions.Users.Update], children: _jsx(Switch, { size: 'medium', checked: switchState, onChange: handleStatusChange }) }) })] })] })), _jsx(DataGrid, { localeText: getDataGridLocaleText(), checkboxSelection: true, rows: users, columns: usersColumns, disableColumnSelector: true, rowCount: rowCount, paginationModel: {
                                        page: userFilters.page - 1,
                                        pageSize: userFilters.pageSize
                                    }, paginationMode: 'server', pageSizeOptions: [10, 20, 50, 100], onPaginationModelChange: handlePaginationModelChange, onRowSelectionModelChange: handleSelectionModelChange, filterMode: 'server', filterDebounceMs: 500, filterModel: filterModel, onFilterModelChange: handleFilterModelChange, sortingMode: 'server', onSortModelChange: handleSortModelChange, hideFooterSelectedRowCount: true, isRowSelectable: isRowSelectable, disableColumnResize: true, slotProps: {
                                        filterPanel: {
                                            filterFormProps: {
                                                operatorInputProps: {
                                                    variant: 'standard'
                                                },
                                                columnInputProps: {
                                                    variant: 'standard'
                                                },
                                                valueInputProps: {
                                                    InputComponentProps: {
                                                        variant: 'standard'
                                                    }
                                                }
                                            }
                                        }
                                    }, sx: {
                                        overflow: 'auto',
                                        borderWidth: '0px',
                                        backgroundColor: 'transparent',
                                        height: __assign(__assign(__assign(__assign({ xs: 'calc(100svh - 294px)', sm: ((_d = selectionModel === null || selectionModel === void 0 ? void 0 : selectionModel.ids.size) !== null && _d !== void 0 ? _d : 0) > 0
                                                ? 'calc(100svh - 310px)'
                                                : 'calc(100svh - 250px)' }, (isscreen600900 && { sm: 'calc(100svh - 330px)' })), (isscreen600900Landscape && { sm: 'calc(100svh - 280px)' })), (iscreen9001200 && { sm: 'calc(100svh - 403px)' })), (iscreen900120Landscape
                                            ? { sm: 'calc(100svh - 326px)' }
                                            : iscreen9001200
                                                ? { sm: 'calc( 100svh - 357px)' }
                                                : {})),
                                        outline: 'none',
                                        '& .MuiDataGrid-row': { cursor: 'default' },
                                        '&, [class^=MuiDataGrid]': { border: 'none' },
                                        '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitleContainer': {
                                            backgroundColor: '#F4F6F8 !important'
                                        }
                                    } })] }) })] })), activationModalOpen && (_jsx(ActivateUserDialog, { user: userStatusModal.user, isOpen: activationModalOpen, onClose: closeUserStatusModal })), deActivationModalOpen && (_jsx(DeActivateUserDialog, { user: userStatusModal.user, isOpen: deActivationModalOpen, onClose: closeUserStatusModal })), multipleActivationModalOpen && (_jsx(ActivateMultipleUsersDialog, { selectedUsers: multipleUserStatusModal.selectedUsers, isOpen: multipleActivationModalOpen, onClose: closeMultipleUserStatusModal, updatedSwitchState: function (activeState) { return setSwitchState(activeState); } })), multipleDeActivationModalOpen && (_jsx(DeActivateMultipleUsersDialog, { selectedUsers: multipleUserStatusModal.selectedUsers, isOpen: multipleDeActivationModalOpen, onClose: closeMultipleUserStatusModal, updatedSwitchState: function (activeState) { return setSwitchState(activeState); } }))] }));
};
export default Users;
